import {connect} from 'react-redux';
import CreateAccreditationRequest from "./CreateAccreditationRequest";
import {getTranslation} from "../../../reducers/common/localization";
import {
    fetchGetTitleLangs,
    getOptionalTitleLangsData
} from "../../../reducers/common/titleLangs";
import {fetchGetLevels, getLevelsData} from "../../../reducers/common/levels";
import {fetchGetVIDs, getVIDsData} from "../../../reducers/applicantAccreditations/VIDs";
import {
    getContinentsData, getCountriesData, getCurrentContinent, getLocationData,
    setCurrentContinent, setCurrentContinentByCountry
} from '../../../reducers/common/location';
import {getUserEmail} from "../../../reducers/account/userData";
import {fetchGetDefaultAlias, getDefaultAliasData} from "../../../reducers/account/aliases";
import {onCreateAccreditationRequest} from "../../../reducers/applicantAccreditations/accreditationRequests";
import {
    fetchGetAGsForRequest, fetchGetOrgByDomain,
    fetchGetOrgsForRequest, getAGsSelectOptionsForRequests, getOrgByDomainCountryOption, getOrgByDomainOption,
    getOrgsSelectOptionsForRequests, loadingOrgByDomain, resetAccreditationGroups, getAGsForRequestError,
    getOrgByDomainNameOption, resetOrganization, resetOrganizations
} from '../../../reducers/applicantAccreditations/accreditationRequestOrgData';
import {MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR, showModal} from "../../../reducers/common/activeModal";
import {getSubmitFormSuccessStatus} from "../../../reducers/common/submitForm";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        additionalLangs: getOptionalTitleLangsData(state),
        levels: getLevelsData(state),
        VIDs: getVIDsData(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        email: getUserEmail(state),
        defaultAlias: getDefaultAliasData(state),
        organizations: getOrgsSelectOptionsForRequests(state),
        accreditationGroups: getAGsSelectOptionsForRequests(state),
        orgByDomain: getOrgByDomainOption(state),
        countryByDomain: getOrgByDomainCountryOption(state),
        orgNameByDomain: getOrgByDomainNameOption(state),
        loadingOrgByDomain: loadingOrgByDomain(state),
        success: getSubmitFormSuccessStatus(state),
        AGError: getAGsForRequestError(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetAdditionalLangs: () => {
            dispatch(fetchGetTitleLangs());
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onGetVIDs: () => {
            dispatch(fetchGetVIDs());
        },
        onGetOrganizations: (country, orgName) => {
            dispatch(fetchGetOrgsForRequest(country, orgName));
        },
        onGetAccreditationGroups: (orgId) => {
            dispatch(fetchGetAGsForRequest(orgId));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onCreate: (data) => {
            dispatch(onCreateAccreditationRequest(data));
        },
        onGetDefaultAlias: () => {
            dispatch(fetchGetDefaultAlias());
        },
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        },
        onGetOrgByDomain: (domain) => {
            dispatch(fetchGetOrgByDomain(domain))
        },
        resetAccreditationGroups: () => {
            dispatch(resetAccreditationGroups());
        },
        resetOrganization: () => {
            dispatch(resetOrganization());
        },
        onOpenErrorModal: () => {
            dispatch(showModal({modalKey: MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR}))
        },
        resetOrganizations: () => {
            dispatch(resetOrganizations());
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CreateAccreditationRequest);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/createAccreditationRequest/CreateAccreditationRequest.container.js